import React from 'react';
import { Box, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { VirtualRoom } from '../services/VirtualRoomStorage';

/**
 * Meeting or cubicle (SC-422). A cubicle shows no name tooltip and can't be booked. The reception
 * is chosen per map in Platform Admin → Maps, so the editor shows it but can't change it.
 */
export const KindPicker: React.FC<{
  value: VirtualRoom['kind'];
  onChange: (kind: 'meeting' | 'cubicle') => void;
  disabled?: boolean;
}> = ({ value, onChange, disabled }) => {
  if (value === 'reception') {
    return (
      <Box data-testid="kind-reception">
        <Typography variant="body2">Reception</Typography>
        <Typography variant="caption" color="text.secondary">
          Change the map's reception in Platform Admin → Maps.
        </Typography>
      </Box>
    );
  }
  return (
    <Box>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        Kind
      </Typography>
      <ToggleButtonGroup
        exclusive
        size="small"
        value={value || 'meeting'}
        disabled={disabled}
        onChange={(_event, kind: 'meeting' | 'cubicle' | null) => kind && onChange(kind)}
        aria-label="Room kind"
      >
        <ToggleButton value="meeting">Meeting</ToggleButton>
        <ToggleButton value="cubicle">Cubicle</ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

export default KindPicker;
